document.addEventListener('DOMContentLoaded', function() {
    const selectors = {
        filter: '[data-filter-careers]',
        careerCards: '[data-career-card]',
        noResults: '[data-no-results]'
    }

    const filter = document.querySelector(selectors.filter);
    const careerCards = document.querySelectorAll(selectors.careerCards);
    const noResults = document.querySelector(selectors.noResults);

    if(!filter || !careerCards) return;

    filter.addEventListener('change', function() {
        const state = this.value;
        let resultsCount = 0;

        careerCards.forEach(card => {
            const cardState = card.getAttribute('data-state');
            if(state === 'All' || cardState === state) {
                card.style.display = 'flex';
                resultsCount++;
            } else {
                card.style.display = 'none';
            }
        });

        if(resultsCount === 0) {
            noResults.style.display = 'flex';
        } else {
            noResults.style.display = 'none';
        }
    });
});